<div class="progress-container">
<div class="stepper">
  <div class="step" *ngFor="let step of steps; let last = last">
    <div class="step-circle" [class.is-completed]="isCompleted(step.number)">
      <span class="step-number" *ngIf="!isCompleted(step.number)">
        {{ step.number }}
      </span>

      <span class="step-icon" *ngIf="isCompleted(step.number)">
        ✓
      </span>
    </div>

  <div class="step-connector" 
           *ngIf="!last"
           [class.is-completed]="isCompleted(step.number)">
      </div>


    <div class="step-label">
      <span class="step-label-text">{{ step.label }}</span>
    </div>
  </div>
</div>

</div>